
import { onMounted, reactive } from 'vue'
import NewActionBar from '@/components/NewActionBar.vue'
import { nativeGoBack } from '../utils/nativeFn'
export default {
  props: {
    showActionBar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NewActionBar
  },
  setup(props, ctx) {
    const clickRefresh = () => {
      ctx.emit('clickRefresh')
    }
    const actionBarInfo = reactive({}) // actionBar需要的参数
    const needShare = false
    // 左侧返回
    const goBack = () => {
      console.log('调用端返回')
      nativeGoBack({}, (res) => {
        console.log('h5调用端上nativeGoBack', res) // app返回给前端的值
      })
    }
    onMounted(() => {
      console.log(props.showActionBar, 'props.showActionBar')
      if (props.showActionBar) {
        Object.assign(actionBarInfo, {
          actionBarTitle: ' ',
          actionBarBg: '#ffffff'
        })
      }
    })
    return {
      clickRefresh,
      needShare,
      actionBarInfo,
      goBack
    }
  }
}
